module.exports = __webpack_public_path__ + "static/media/feedback_card_delete_btn.a8026d31.svg";